export default __webpack_public_path__ + "static/media/Flag of Grenada.bd9d260e.gif";